<template>
  <v-dialog v-model="dialog" @click:outside="close" width="600" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Costo Adicional</span>
      </v-card-title>

      <v-card-text>
        <v-textarea
          autocomplete="off"
          name="observacion_resultado"
          label="Descripcion*"
          v-model="item.observacion_resultado"
          v-validate="'required'"
          data-vv-as="Descripcion"
          rows="3"
        />
        <span class="red--text">{{ errors.first("observacion_resultado") }}</span>

        <v-text-field
          autocomplete="off"
          name="value_used"
          label="Costo*"
          type="number"
          step="0.01"
          v-model="item.value_used"
          v-validate="'required|decimal|min_value:0.01'"
          data-vv-as="Costo"
          prefix="$"
        />
        <span class="red--text">{{ errors.first("value_used") }}</span>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close"> Cerrar </v-btn>
        <v-btn color="success" text @click="save"> {{ isEdit ? 'Guardar' : 'Agregar' }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    itemEdit: Object,
    editIndex: Number,
  },
  data: () => ({
    item: {
      observacion_resultado: null,
      value_used: null,
    },
    defaultItem: null,
  }),
  computed: {
    isEdit() {
      return this.itemEdit != null && this.editIndex != null;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.errors.clear();
        if (this.itemEdit != null) {
          this.item = Object.assign({}, this.itemEdit);
        } else {
          this.item = Object.assign({}, this.defaultItem);
        }
      }
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    save() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.$emit("updateItem", this.item, this.editIndex);
          } else {
            this.$emit("addItem", this.item);
          }
          
          this.close();
        }
      });
    },
    close() {
      this.$emit("updateDialog", false);
      this.item = Object.assign({}, this.defaultItem);
    },
  },
};
</script>

<style scoped>
</style>
